import React from "react";

import { Box, Modal, IconButton } from "@mui/material";

import { Close } from "@mui/icons-material";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	bgcolor: "background.paper",
	boxShadow: 24,
	p: 4,
	maxHeight: "90vh",
	overflow: "auto",
	zIndex: 1000,
	boxSizing: "border-box"
};

const ModalComponent = ({
	children,
	open,
	handleCloseModal,
	width,
	isSmallerScreen
}: {
	children: React.ReactNode;
	open: boolean;
	handleCloseModal: () => void;
	width: string;
	isSmallerScreen?: boolean;
}) => {
	return (
		<Modal open={open} onClose={handleCloseModal}>
			<Box sx={style} width={width} style={{ padding: isSmallerScreen ? "20px" : "30px" }}>
				<Box display="flex" justifyContent="flex-end" style={{ position: "absolute", right: "20px", top: "20px" }}>
					<IconButton onClick={handleCloseModal}>
						<Close />
					</IconButton>
				</Box>
				{children}
			</Box>
		</Modal>
	);
};

export default ModalComponent;
